// extracted by css-extract-rspack-plugin
export default {"btnarea":"ShowMoreBtn__btnarea--LNY5b","btn":"ShowMoreBtn__btn--aPdEo","btnOpend":"ShowMoreBtn__btnOpend--vswT4"};